// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__+21lk","disabled":"styles_disabled__YHiDn"};